import axios from 'axios';
import getHeaders from '../../constants/headers';
import { CONSUMER_BASE_URL } from '../BaseURL';

export const getBrandCustomer = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      CONSUMER_BASE_URL +
      '/api/secure/v2/brand/' +
      brandId +
      '/brand-customer',
    headers:  getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getBrandCustomerV3 = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      CONSUMER_BASE_URL +
      '/api/secure/v3/brand/' +
      brandId +
      '/brand-customer',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getBrandCustomerV4 = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      CONSUMER_BASE_URL +
      '/api/secure/v4/brand/' +
      brandId +
      '/brand-customer',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const brandAllCustomerData = (brandId) => {
  return axios({
    method: "get",
    url:
      CONSUMER_BASE_URL +
      "/api/secure/v1/brand/" +
      brandId +
      "/brand-store-customer",
    headers: getHeaders(),
  });
};


export const brandCustomerUpload = (brandId, uploadFile, mapWithStore) => {
  const formData = new FormData();
  formData.append("uploadFile", uploadFile); // Assuming 'file' is the file object you want to upload
  formData.append("mapWithStore", mapWithStore); // Assuming 'file' is the file object you want to upload

  return axios({
    method: "post",
    url:
      CONSUMER_BASE_URL + "/api/secure/v1/brand/" + brandId + "/brand-customer",
    data: formData,
    headers: getHeaders("multipart/form-data"),
  });
};